import { toJS } from 'mobx';
import convertUnicode from '~/common/utils/convertUnicode.js';

export function mapData(obj, data) {
    // convert the observable to json
    let newObj = toJS(obj);
    Object.keys(newObj).map((key) => {
        if (typeof data[key] === typeof newObj[key]) {
            // translate strings
            if (typeof data[key] == "string") {
                // if we are expecting the data, use it else lose it
                return newObj[key] ? newObj[key] = convertUnicode(data[key]) : null;
            }
            else if (typeof data[key] == "object") {
                let translatedObj = [];
                Object.keys(data[key]).map((key2) => {
                    translatedObj[key2] = convertUnicode(data[key][key2]);
                });
                // if we are expecting the data, use it else lose it
                return newObj[key] ? newObj[key] = translatedObj : null;
            }
            else {
                // if we are expecting the data, use it else lose it
                return newObj[key] ? newObj[key] = data[key] : null;
            }
        } else {
            console.log('Invalid JSON passed', data[key], key);
        }
    });

    return newObj;
}
